var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_760_1",
    "data-name": "Component 760 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.093,
    height: 20.272,
    viewBox: "0 0 20.093 20.272",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7356",
    "data-name": "Group 7356",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1421",
    "data-name": "Rectangle 1421",
    transform: "translate(-0.001)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "none"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7360",
    "data-name": "Group 7360",
    transform: "translate(-852.169 -953.803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5923",
    "data-name": "Path 5923",
    d: "M12.446,15.078l-.627-.627,4.411-7.316.062.061A1.41,1.41,0,1,0,18.285,5.2L14.246,1.165a1.41,1.41,0,1,0-1.993,1.993l.061.062L5,7.63,4.37,7A1.385,1.385,0,0,0,2.412,7l-.61.609a1.386,1.386,0,0,0,0,1.958l8.076,8.076a1.385,1.385,0,0,0,1.958.007h0l.613-.613A1.385,1.385,0,0,0,12.446,15.078Z",
    transform: "translate(852.682 954.254)",
    fill: "none",
    stroke: "#213960",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_634",
    "data-name": "Line 634",
    x1: 5.2,
    y2: 5.022,
    transform: "translate(853.37 967.992)",
    fill: "none",
    stroke: "#213960",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_635",
    "data-name": "Line 635",
    x2: 6.697,
    y2: 6.697,
    transform: "translate(857.679 961.883)",
    fill: "none",
    stroke: "#213960",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_636",
    "data-name": "Line 636",
    x2: 4.038,
    y2: 4.038,
    transform: "translate(864.935 957.411)",
    fill: "none",
    stroke: "#213960",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinn);
export default __webpack_public_path__ + "static/media/pinn.863af3ebe9ed2ce70d5b3dfbd14d05df.svg";
export { ForwardRef as ReactComponent };